<script setup>
import { useContextStore } from "@/store/context";
import { usePanierStore } from "@/store/panier";
import panierMapper from "@/services/panier/panier-mapper";

const { layout } = storeToRefs(useContextStore());
const { getArticlesById, syncArticles } = usePanierStore();

const emit = defineEmits(["addToCart", "deleteFromCart", "plageSelected"]);

const props = defineProps({
  article: {
    type: Object,
    required: true
  }
});

const articlesLines = computed(() => getArticlesById(props.article.id));

const removeAllArticles = (linesToChange = articlesLines.value) => {
  const articles = linesToChange.map((ligne) => {
    return {
      ...panierMapper.getArticleModel(ligne),
      quantite: 0
    };
  });
  syncArticles(articles);
};

const component = computed(() => {
  return defineAsyncComponent(
    lazyComponents[
      `/components/organisms/pft-plage-selector/${layout.value}.vue`
    ]
  );
});
</script>
<template>
  <component
    :is="component"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    :selected-plages="articlesLines"
    :article="article"
    @addToCart="
      (value) => {
        emit('addToCart', value);
      }
    "
    @plageSelected="
      (value) => {
        emit('plageSelected', value);
      }"
    @deleteFromCart="removeAllArticles"
  />
</template>
